/*
*   main page that renders challenges under a stream
*   that is assigned to a user
*/
import Styles from './UserChallenges.module.scss';
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// Components imports.
import { useAPI } from 'components/lib';
import GridViewCard from 'components/global/GridViewCard/GridViewCard';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import { BreadCrumbs } from 'components/global/BreadCrumbs/BreadCrumbs';

export function UserChallenges(props) {
	const { stream_id } = useParams();
	// const [isListView, setListView] = useState(false);

	const navigate = useNavigate();

	const handleClick = (data) => {
		const id = data.id;
		navigate(`/streams/${stream_id}/challenges/${id}/instructions`);
	};

	const [challengeList, setChallengeList] = useState([]);
	const { data, loading } = useAPI(`/api/user/streams/${stream_id}/challenges`, 'GET');

	useEffect(() => {
		if (data) {
			const updatedChallengeList = data.challengeDetails.map(challenge => ({
				...challenge,
				// isDisabled: (challenge.status === "Failed" || challenge.status === "Completed"),
				isDisabled: false,
				isFailed: (challenge.status === "Failed") ? true : false,
				buttonText: (challenge.status === "Not Complete") ? "Continue Challenge" :
					(challenge.status === "Completed") ? "Completed" :
						(challenge.status === "Failed") ? "Retake" : "Start Challenge"
			}));
			setChallengeList(updatedChallengeList);;
		}
	}, [data]);



	return (
		<>
			<div className={Styles.CardContainer}>
				<>
					<div className={Styles.tabContainer}>
						<BreadCrumbs
							onClickPaths={[
								'/streams',
								''
							]}
							crumbs={[
								props.t('Streams.UserChallenges.breadcrumbs.streams'),
								data?.streamName ? `${data?.streamName}: ${props.t('Streams.UserChallenges.breadcrumbs.challenges')}` : props.t('Streams.UserChallenges.breadcrumbs.challenges')
							]}
						/>
					</div>
					<>
						<div style={{ display: 'flex', flexWrap: 'wrap' }}>
							{loading ? (
								<div>
									<LoadingBackdrop isOpen={true} />
								</div>
							) : challengeList.length > 0
								? challengeList.map((challenge) => <GridViewCard
									data={challenge}
									key={challenge.id}
									onClick={handleClick}
									showInfoChips={true}
									showMedalChips={true}
									button_text={challenge.buttonText} />)
								: "{t('Streams.UserChallenges.message')}"}
						</div>
					</>
				</>
			</div>
		</>
	);
}
